"use client";
import ReactMarkdown from "react-markdown";
export default function LegalDisplay({title, content}){
    return(
      <section>
          <h1 className={"title-primary text-center"}>{title}</h1>
          <ReactMarkdown
              className={'px-9 pb-9 whitespace-pre-line'}
              components={{
                  p: ({children}) => <p className="mb-md">{children}</p>,
                  h2: ({children}) => <p className="text-3xl text-primary">{children}</p>,
                  h3: ({children}) => <p className="text-2xl text-primary">{children}</p>,
                  a: ({children, href}) => <a href={href} target="_blank" rel='noreferrer' className='link-primary transition-all duration-300 ease-out'>{children}</a>
              }}
          >
              {content}
          </ReactMarkdown>
      </section>
    );
}
